import { Backend } from '@/_axios';

export default {
  list(projectId, params) {
    return Backend.get(`/project/${projectId}/json_schemas/`, { params });
  },
  createData(projectId) {
    return Backend.get(`/project/${projectId}/json_schemas/create`);
  },
  editData(projectId, id) {
    return Backend.get(`/project/${projectId}/json_schemas/${id}/edit`);
  },
  create(projectId, data) {
    return Backend.post(`/project/${projectId}/json_schemas/`, data);
  },
  update(projectId, data) {
    return Backend.put(`/project/${projectId}/json_schemas/${data.schema_data.id}`, data);
  },
  delete(projectId, id) {
    return Backend.delete(`/project/${projectId}/json_schemas/${id}`);
  },
};
